<template>
  <div class="loginContainer">
    <div class="loginContent" v-if="loginStatus!=='register'" @click="showSelect = false">
      <img :src="cancel" alt="" class="pointer" @click="close">
      <div class="title">{{ $t('lang.login.login') }}</div>
      <div class="body" :style="picSwitch?'height:260px':''" v-if="loginStatus==='login'">
        <div class="text1 mb40">{{ $t('lang.setting.mobile')}}</div>
        <div class="inputRow">
          <div class="select pointer">
            <div class="text3"></div>
            <div class="input" @click.stop="showSelect = !showSelect">+{{countryCode}}</div>
            <img :src="triangle" :class="{rotate: showSelect}" alt="" @click.stop="showSelect = !showSelect">
            <div class="selectList" v-show="showSelect">
              <div class="option pointer" v-for="(item, index) in countryCodeList" :key="index" @click="select('countryCode', item.value)">{{item.label}}</div>
            </div>
          </div>
          <input v-model="tel"/>
        </div>
        <div class="inputRow" style="margin-top: 25px;" v-if="picSwitch">
          <input v-model="pictureCode" style="flex: 2.5" maxlength="4"/>
          <div class="select" style="flex: 1;background-color: #FFDB99;" @click="initPicture">
            <img :src="codePicture"
                 style="margin:0 auto;padding-top:5px;background-color: #FFDB99;width:50%;height: 100%;">
          </div>
        </div>
      </div>
      <div class="body" v-if="loginStatus==='sns'">
        <div class="text2 mb15">{{ $t('lang.login.snsPrompt1') }} <span style="font-weight: bold;">+{{countryCode}}{{tel}}</span> {{ $t('lang.login.snsPrompt2')}}</div>
        <div class="inputRow">
          <input v-model="sns"/>
        </div>
        <div class="textErr" v-show="showErr">{{ $t('lang.login.incorrectCode') }}</div>
      </div>
      <div class="body" v-if="loginStatus==='register'">
        <div class="mb25" style="display: flex">
          <div class="text2" style="flex: 1;margin-right: 20px;">{{ $t('lang.common.currency') }}</div>
          <div class="text2" style="flex: 2;">{{ $t('lang.login.Username') }}</div>
        </div>
        <div class="inputRow">
          <div class="select pointer">
            <div/>
            <div class="input" @click.stop="showSelect = !showSelect">{{ currency }} {{ fetchCurrency[currency] }}</div>
            <img :src="triangle" :class="{rotate: showSelect}" alt="">
            <div class="selectList" v-show="showSelect">
              <div class="option pointer" v-for="(item, index) in currencyList" :key="index"
                   @click="select('currency', item.value)">{{ item.label }}
              </div>
            </div>
          </div>
          <input v-model="userName"/>
        </div>
      </div>
      <div>
        <div class="submit pointer" @click="handleSubmit">{{ $t('lang.login.Submit') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/images/common/cancel_black.svg'
import triangle from '@/assets/images/common/triangle.svg'
import {fetchCurrency} from '@/constant'
import request from '@/service'
import {LogUtils} from '@/utils'
import {mapMutations} from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      cancel,
      triangle,
      showSelect: false,
      countryCode: '91',
      tel: '',
      picSwitch: false, // 图形验证开关
      pictureCode: '', // 验证码
      codePicture: '', // 图形
      sns: '',
      currency: 'INR',
      userName: '',
      loginStatus: 'login', // login, sns, register
      showErr: false,
      inviteCode: '',
      shareType: '',
      fetchCurrency,
      countryCodeList: [
        {
          label: '+91',
          value: '91'
        }
      ],
      currencyList: [
        {
          label: 'INR ₹',
          value: 'INR'
        }
        // {
        //  label: 'USD $',
        //  value: 'USD'
        // },
        // {
        //  label: 'EUR €',
        //  value: 'EUR'
        // }
        // {
        //  label: 'CNY ￥',
        //  value: 'CNY'
        // }
      ]
    }
  },
  mounted () {
    if (!localStorage.getItem('visitorCode')) {
      LogUtils.getVisitorCode()
    }
    this.initPicture()
    this.shareType = localStorage.getItem('shareType')
    this.inviteCode = localStorage.getItem('shareCode') ? localStorage.getItem('shareCode') : null
  },
  methods: {
    ...mapMutations({
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale'
    }),
    initPicture () {
      const url = '/innovation/account/get/rvc'
      const data = {SessionCode: localStorage.getItem('visitorCode')}
      request('post', url, data, true).then(res => {
        if (res) {
          this.picSwitch = res.Switch
          this.codePicture = res.Image
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleSubmit () {
      switch (this.loginStatus) {
        case 'login':
          this.getSns()
          break
        case 'sns':
          this.login()
          break
        case 'register':
          this.register()
          break
      }
    },
    getSns () {
      if (!this.tel) {
        this.$message.error(this.$t('lang.common.fail'))
        return
      }

      const url = '/innovation/account/sendsns'
      const data = {
        SnsCode: this.pictureCode,
        visitorCode: localStorage.getItem('visitorCode'),
        mobile: this.tel,
        countryCode: this.countryCode,
        campaignId: localStorage.getItem('cid'),
        InviteCode: 'web' // 22年12月增加了邀请码，导致web端无法登录
      }
      request('post', url, data).then(res => {
        if (res.Code === 60002) {
          this.$message.error('Invalid captcha!')
          this.pictureCode = ''
          this.initPicture()
          return
        } else if (res.Code === 10003) {
          this.$message.error(
            this.$t('lang.login.abnormalPrompt1') +
            ' mailto:support@pgebet.com ' +
            this.$t('lang.login.abnormalPrompt2') + ' ' +
            this.$t('lang.login.abnormalPrompt3') + ' ' +
            this.$t('lang.login.abnormalPrompt4'))
          return
        }
        this.loginStatus = 'sns'
        this.sns = res.CodeForTestOnly // todo test
      }).catch(() => {
        this.pictureCode = ''
        this.initPicture()
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    /***
     * 2022-04-28 CHP Fix 验证码错误时仍跳到了注册页面
     */
    login () {
      const url = '/innovation/account/login'
      const data = {
        mobile: this.tel,
        countryCode: this.countryCode,
        snsCode: this.sns
      }
      request('post', url, data).then(res => {
        if (res.Code) {
          if (res.Code === 1) {
            localStorage.setItem('userInfo', JSON.stringify({
              telNum: this.tel,
              ...res
            }))

            this.setInternation(res.Internation)
            this.setInternationName(res.InternationName)
            this.setLocale(res.Locale)
            this.$i18n.locale = res.Locale // 设置语言

            this.$router.go(0)
          } else if (res.Code === 3) {
            this.$message.error(this.$t('lang.login.codeExpired'))
            this.loginStatus = 'login'
          } else {
            this.loginStatus = 'register'
            this.handleSubmit()
          }
        } else {
          this.showErr = true
          this.$message.error(this.$t('lang.common.fail'))
        }
      }).catch((err) => {
        console.log(err)
        this.showErr = true
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    register () {
      const url = '/innovation/account/register'
      const data = {
        mobile: this.tel,
        countryCode: this.countryCode,
        currencyName: this.currency,
        snsCode: this.sns,
        campaignId: localStorage.getItem('cid'),
        internation: this.$store.state.internation,
        visitorCode: localStorage.getItem('visitorCode'),
        shareCode: this.inviteCode,
        shareType: this.shareType ? this.shareType : ''
      }
      request('post', url, data).then(res => {
        if (res.Code === 0) {
          localStorage.setItem('userInfo', JSON.stringify({
            telNum: this.tel,
            ...res
          }))
          this.$router.go(0)
        } else if (res.Code === 10000) {
          this.$message.error(this.$t('lang.message.usernameExit'))
        } else if (res.Code === 10001) {
          this.$message.error(this.$t('lang.message.mobileExit'))
        } else if (res.Code === 60001) {
          this.$message.error(this.$t('lang.login.codeExpired'))
        } else if (res.Code === 60002) {
          this.$message.error(this.$t('lang.login.codeExpired'))
        } else {
          this.$message.error(this.$t('lang.message.registerFail'))
        }
      }).catch(() => {
        this.$message.error(this.$t('lang.common.fail'))
      })
    },
    select (type, val) {
      this[type] = val
      this.showSelect = false
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>

<style lang="less" scoped>
  .loginContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.8);
    z-index: 10;
    .loginContent {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: -28px;
        right: -28px;
        width: 28px;
      }
      .title {
        font-size: 34px;
        line-height: 55px;
        font-weight: bold;
        color: #543200;
        text-align: center;
        background: #F6D9AA;
        border-radius: 10px 10px 0 0;
      }
      .body {
        width: 520px;
        height: 220px;
        padding: 33px 55px 40px;
        margin-bottom: 40px;
        background: #212324;
        border-radius: 0 0 10px 10px;
        .text1 {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
        }
        .text2 {
          font-size: 14px;
          line-height: 24px;
          color: #F6D9AA;
        }
        .text3 {
          font-size: 12px;
          line-height: 14px;
          color: #F6D9AA;
        }
        .textErr {
          margin-top: 10px;
          font-size: 16px;
          line-height: 19px;
          color: #f00;
        }
        .inputRow {
          display: flex;
          height: 40px;
          .select, input {
            /*height: 100%;*/
            font-size: 16px;
            line-height: 40px;
            color: #ffffff;
            text-align: center;
            letter-spacing: 0.1em;
            border: 1px solid rgba(246, 217, 170, 0.5);
            &:first-child {
              flex: 1;
              margin-right: 20px;
            }
            &:last-child {
              flex: 2;
            }
          }
          .select {
            position: relative;
            display: flex;
            align-items: center;
            >div:first-child {
              position: absolute;
              left: 0;
              top: -20px;
            }
            .input {
              /*height: 100%;*/
              flex: 1;
            }
            img {
              height: 14px;
              width: 12px;
              margin-right: 10px;
              transition: transform .3s;
              /*position: absolute;*/
              /*top: 50%;*/
              /*transform: translateY(-50%);*/
              /*right: 15px;*/
            }
            .selectList {
              position: absolute;
              left: 0;
              top: 50px;
              padding: 15px 0;
              width: max-content;
              text-align: left;
              background: #202020;
              border: 1px solid rgba(246, 217, 170, 0.5);
              border-radius: 0 0 10px 10px;
              cursor: default;
              .option {
                padding: 0 15px;
                line-height: 30px;
                &:hover {
                  background: #333;
                }
              }
            }
            .rotate {
              transform: translateY(-50%);
              transform: rotate(90deg);
            }
          }
        }
      }
      .submit {
        float: right;
        width: 200px;
        height: 50px;
        font-size: 22px;
        line-height: 50px;
        color: #000;
        text-align: center;
        background: #F6D9AA;
        box-shadow: 0 5px 10px rgba(255, 176, 48, 0.61);
        border-radius: 6px;
      }
    }
    .mb40 {
      margin-bottom: 40px;
    }
    .mb15 {
      margin-bottom: 15px;
    }
    .mb25 {
      margin-bottom: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue